import React from 'react';
import { templateRegistry } from '../../../templates';
import type { TemplateProfile } from '../../../templates';
import { useTemplateStore } from '../../store/templateStore';
import TemplateCard from './TemplateCard';
import { Button, Spinner, makeStyles } from '@fluentui/react-components';
import { useActiveTemplate } from '../../hooks/useActiveTemplate';
import { useApplyTemplate } from '../../hooks/useApplyTemplate';
import ErrorBoundary from '../shared/ErrorBoundary';

const useStyles = makeStyles({
  templateGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '16px',
    marginBottom: '16px',
  },
  templateItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
    width: '180px',
    margin: '0 auto',
  },
  applyRow: { display: 'flex', flexDirection: 'column', gap: '8px' },
  statusArea: { minHeight: '32px' },
});

export default function TemplatesPanel(): React.ReactElement {
  const styles = useStyles();
  const profiles = templateRegistry.getAll();
  const activeTemplateId = useTemplateStore((s) => s.activeTemplateId);
  const { setTemplate } = useActiveTemplate();
  const { apply, isApplying } = useApplyTemplate();

  return (
    <ErrorBoundary fallback={null}>
      <div>
        <div className={styles.templateGrid}>
          {profiles.map((p: TemplateProfile) => (
            <div key={p.id} className={styles.templateItemWrapper}>
              <TemplateCard profile={p} isActive={p.id === activeTemplateId} onSelect={() => setTemplate(p.id)} />
            </div>
          ))}
        </div>

        <div className={styles.applyRow}>
          <div className={styles.statusArea} />
          <Button
            appearance="primary"
            size="large"
            disabled={isApplying}
            onClick={apply}
            icon={isApplying ? <Spinner size="tiny" aria-label="Applying template" /> : undefined}
            aria-label="Apply selected template"
          >
            {isApplying ? 'Applying…' : 'Apply Template'}
          </Button>
        </div>
      </div>
    </ErrorBoundary>
  );
}
